import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["nps_select", "current_page"];

  filterNpsResponses(page) {
    let filter = this.nps_selectTarget.value;

    if (!Number.isInteger(page)) {
      page = 1;
    }

    $.ajax({
      url: "/nps.js",
      method: "GET",
      data: { filter, page },
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
      }
    }).done(data => {
      $(this.containerTarget).append(data);
    });
  }

  nextPage() {
    let page = parseInt(this.current_pageTarget.id);
    let nextPage = (page += 1);

    this.filterNpsResponses(nextPage);
  }

  previousPage() {
    let page = parseInt(this.current_pageTarget.id);
    let previousPage = (page -= 1);

    this.filterNpsResponses(previousPage);
  }
}
